import Picture from './../core/model/picture.model';

export class CommunicationToolCategory {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.slug = data.slug;
    this.isOnline = data.online;
  }
}

export class CommunicationToolCollection {
  constructor(data = {}) {
    this.id = data.id;
    this.name = data.title;
    this.isOnline = data.online;
    this.cover = new Picture(data.image || {});
    this.category = new CommunicationToolCategory(data.category);
  }
}

export class CommunicationToolItem {
  constructor(data = {}) {
    this.id = data.id;
    this.cover = new Picture(data.file || {});
    this.name = data.title;
    this.collection = new CommunicationToolCollection(data.tool);
    this.category = new CommunicationToolCategory(data.tool.category);
    this.relatedProducts = data.relatedProducts;
  }
}



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool.model.js